if (typeof wpcf7 !== 'undefined') {
  wpcf7.cached = 0;
}

var _km_consultados_set = new Set();
var _duracion_consultadas_set = new Set();

var _gtmListo = null;
function pushConGate(payload) {
  _gtmListo = new Promise(function (resolve) {
    var hecho = false;
    var fin = function () { if (!hecho) { hecho = true; resolve(); } };
    payload.eventCallback = fin;
    payload.eventTimeout = 2000;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    setTimeout(fin, 2000);
  });
  return _gtmListo;
}
function esperarGTM() {
  return _gtmListo || Promise.resolve();
}

jQuery(document).ready(function ($) {

  //******  SCRIPT PRECIOS

  function format_as_euro(amount) {
    var numericAmount = parseFloat(amount);

    if (!isNaN(numericAmount)) {
      return numericAmount.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
    } else {
      return false;
    }
  }

  //// errors control
  window.onerror = function (message, source, lineno, colno, error) {
    if (message === 'Script error.' || !source) {
      return true;
    }
    console.warn('Error detectado:', { message, source, lineno, colno, error });
    return false;
  };

  window.addEventListener('unhandledrejection', function (event) {
    event.preventDefault();
  });


  function actualizar_kmmeses(scope) {
    const compra_flexible = location.href.includes('compra-flexible');
    var $scope = scope ? jQuery(scope) : jQuery(document);

    $scope.find('.mesesvar').each(function () {
      var $form = jQuery(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      var $mesesVar = $form.find('.mesesvar');
      var $kmVar = $form.find('.kmvar');

      var $idCampanaInput = $form.find('[id^="idcampana"]');
      var localIdCampana = $idCampanaInput.val() || (typeof idcampana !== 'undefined' ? idcampana : 0);

      $mesesVar.find('option').remove();
      $kmVar.find('option').remove();

      if (window["arr_km_" + localIdCampana]) {
        $kmVar.append(window["arr_km_" + localIdCampana]);
      }

      const kmValue = $kmVar.val();
      if (window["options_km_" + localIdCampana] && kmValue && window["options_km_" + localIdCampana][kmValue]) {
        $mesesVar.append(window["options_km_" + localIdCampana][kmValue]);
      }

      try {
        const currentKm = $kmVar.val();
        const currentMeses = $mesesVar.val();
        const str = currentKm && currentMeses ? currentKm + '|' + currentMeses : null;

        if (str && window["arr_tarifas_" + localIdCampana]) {
          if (compra_flexible == true && window["vfr_cp_" + localIdCampana]) {
            var price = window["vfr_cp_" + localIdCampana][str];
            var formattedPrice = format_as_euro(price);
            $form.find('.item-price-final').html('<small class="text--grey">Cuota final ' + formattedPrice + ' o lo devuelves sin coste adicional </small>');
          }

          var tarifa = window["arr_tarifas_" + localIdCampana][str];
          if (tarifa !== undefined) {
            $form.find('p#item-price, p#item-price-down').html(tarifa + ' &#8364;');
            $form.find('.item-price-siniva').html((tarifa / 1.21).toFixed(0) + ' &#8364; <small>+ IVA</small>');
          }
        }
      } catch (error) {
        console.error("Error al actualizar precios:", error);
      }
    });
  }

  $(document).ready(function () {

    var ref = document.referrer || '';
    var loc = window.location.href || '';
    var isDetailPage = $('.c-selector, .card-detail, .combo').length > 0;
    var targetType = '';
    if (loc.indexOf('renting-autonomos') !== -1) {
      targetType = 'Autonomo';
    } else if (loc.indexOf('renting-empresas') !== -1) {
      targetType = 'Empresa';
    } else if (loc.indexOf('renting-particulares') !== -1 || loc.indexOf('renting-coches') !== -1) {
      targetType = 'Particular';
    } else if (isDetailPage) {
      if (ref.indexOf('renting-autonomos') !== -1) {
        targetType = 'Autonomo';
      } else if (ref.indexOf('renting-empresas') !== -1) {
        targetType = 'Empresa';
      } else if (ref.indexOf('renting-particulares') !== -1) {
        targetType = 'Particular';
      }
    } else {
      targetType = 'Particular';
    }

    if (targetType) {
      $('.client-type').each(function () {
        var selector = 'input[name="client-type"][value="' + targetType + '"]';
        if (targetType === 'Autonomo') {
          selector += ', input[name="client-type"][value="Autónomo"]';
        }
        var $radio = $(this).find(selector);
        if ($radio.length) {
          $radio.prop('checked', true);
        }
      });
    }

    if (typeof window.idcolor !== 'undefined' && window.idcolor) {
      $('[id^="idcolor"]').each(function () {
        if (!$(this).val()) {
          $(this).val(window.idcolor);
        }
      });
    }

    $(document).on('click', '.checking li', function (e) {
      var $form = $(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      var localIdCampana = $(this).attr('data-idcampana') || $(this).data('idcampana');
      var localIdColor = $(this).attr('data-name') || $(this).data('name');

      if (localIdColor !== undefined && localIdColor !== null && localIdColor !== "") {
        $('.c-selector__color__value, .check-colors').text(localIdColor);

        $('.checking li').removeClass('active');
        $('.checking li').filter(function () {
          return $(this).attr('data-name') === localIdColor;
        }).addClass('active');
      }

      var $targetForm = $form.length ? $form : $(document);
      $targetForm.find('[id^="idcampana"], [name="idcampana"]').val(localIdCampana);
      $targetForm.find('[id^="idcolor"], [name="idcolor"]').val(localIdColor);

      $targetForm.find('[id^="idcampana"], [name="idcampana"]').each(function () {
        this.value = localIdCampana;
        $(this).trigger('change');
        this.dispatchEvent(new Event("change", { bubbles: true }));
      });
      $targetForm.find('[id^="idcolor"], [name="idcolor"]').each(function () {
        this.value = localIdColor;
        $(this).trigger('change');
        this.dispatchEvent(new Event("change", { bubbles: true }));
      });
      actualizar_kmmeses($form.length ? $form : undefined);
    });

    $(document).on('change', '.kmvar', function () {
      var $form = $(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      var $mesesVar = $form.find('.mesesvar');
      var previousmeses = $mesesVar.val();

      $mesesVar.find('option').remove();

      var kmValue = $(this).val();
      var safeIdCampana = (typeof idcampana !== 'undefined' ? idcampana : 0);
      if (window["options_km_" + safeIdCampana] && kmValue && window["options_km_" + safeIdCampana][kmValue]) {
        $mesesVar.append(window["options_km_" + safeIdCampana][kmValue]);
      }

      $mesesVar.find('option').each(function () {
        if ($(this).val() == previousmeses) {
          $(this).prop('selected', true);
        }
      });

      actualizar_precios_scope($form);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('kmvar') && e.target.value) {
        var kmValue = e.target.value;
        var scope = e.target.closest('.card-single, .combo, .card-detail, .wrapper-selects, .block--inputs') || document;
        var kmLabelEl = scope.querySelector('.c-custom-select[id^="select-km"] .c-custom-select__value');
        var kmLabel = kmLabelEl ? kmLabelEl.textContent.trim() : (kmValue + ' Km');
        _km_consultados_set.add(kmLabel);
      }
      if (e.target && e.target.classList.contains('mesesvar') && e.target.value) {
        var mesesValue = e.target.value;
        var scope = e.target.closest('.card-single, .combo, .card-detail, .wrapper-selects, .block--inputs') || document;
        var mesesLabelEl = scope.querySelector('.c-custom-select[id^="select-meses"] .c-custom-select__value');
        var mesesLabel = mesesLabelEl ? mesesLabelEl.textContent.trim() : (mesesValue + ' Meses');
        _duracion_consultadas_set.add(mesesLabel);
      }
    });

    $(document).on('change', '.mesesvar', function () {
      var $form = $(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      actualizar_precios_scope($form);
    });

    function actualizar_precios_scope($form) {
      const safeIdCampana = (typeof idcampana !== 'undefined' ? idcampana : 0);
      const compra_flexible = location.href.includes('compra-flexible');
      const kmValue = $form.find('.kmvar').val();
      const mesesValue = $form.find('.mesesvar').val();
      const str = kmValue && mesesValue ? kmValue + '|' + mesesValue : null;

      if (str && window["arr_tarifas_" + safeIdCampana]) {
        if (compra_flexible == true && window["vfr_cp_" + safeIdCampana]) {
          var price = window["vfr_cp_" + safeIdCampana][str];
          var formattedPrice = format_as_euro(price);
          $form.find('.item-price-final').html('<small class="text--grey">Cuota final ' + formattedPrice + ' o lo devuelves sin coste adicional </small>');
        }

        var tarifa = window["arr_tarifas_" + safeIdCampana][str];
        $form.find('p#item-price, p#item-price-down').html(tarifa + ' &#8364;');
        $form.find('.item-price-siniva').html((tarifa / 1.21).toFixed(0) + ' &#8364; <small>+ IVA</small>');
      }
    }

    actualizar_kmmeses();

  });



  //******  BUTTON MOBILE

  $(window).scroll(function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 200) {
      $('#bottom-footer').addClass('is-fixed');
    } else {
      $('#bottom-footer').removeClass('is-fixed');
    }
  });

  //******  PERMITIR SOLO NUMEROS EN EL INPUT TELEFONO y AÑADIR BOTON CERRAR

  $(document).on('input', '.wpcf7-tel, input[name="telefono"]', function () {
    this.value = this.value.replace(/\D/g, '').slice(0, 9);
  });

  $(document).on('mailsent.wpcf7', function () {
    $('.close-send').addClass('visible');
  });


});
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//funcion para activar/desactivar el botón enviar del nuevo formulario
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function validaAvisoCheckbox(element_original, id) {
  var botonEnviar = document.getElementsByClassName(id);
  Array.from(botonEnviar).forEach(function (element, index, array) {
    if (element_original.checked == true) {
      element.disabled = false;
    } else {
      element.disabled = true;
    }
  });


}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
//funcion prepararEnvioF : recoge los datos que antes se llevaban por ContactForm7 en base al id del form (url de la pagina en la que esté)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function validateEmail_cf(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/;
  return re.test(String(email).toLowerCase());
}


function validateForm(formId, fieldName, triggerEl) {
  var currentForm = null;
  if (triggerEl && triggerEl.closest) {
    currentForm = triggerEl.closest('form');
  } else if (typeof window !== 'undefined' && window.event && window.event.target && window.event.target.closest) {
    currentForm = window.event.target.closest('form');
  }

  var formIdTrim = (typeof formId === 'string') ? formId.trim() : '';

  if (!currentForm && formIdTrim) {
    currentForm = document.querySelector(`[data-id="${formIdTrim}"]`);
  }
  if (!currentForm && formIdTrim) {
    currentForm = document.getElementById(formIdTrim);
  }
  if (!currentForm && formIdTrim) {
    currentForm = document.querySelector(`[data-id*="${formIdTrim}"]`);
  }
  if (!currentForm) return;

  var invalidFields = [];

  if (fieldName) {
    validateFormFields(currentForm, fieldName);
  } else {
    var requiredFields = [...currentForm.querySelectorAll("[data-required]")];
    invalidFields = requiredFields.map((field) => validateFormFields(currentForm, field.name));
  }

  if (invalidFields.length > 0 && !invalidFields.some(field => field === false)) {
    var targetId = currentForm.getAttribute('data-id') || formIdTrim;
    prepararEnvioF(targetId, currentForm);
  }
}

const validateFormFields = (currentForm, fieldName) => {
  if (!currentForm) return false;
  const field = currentForm.querySelector(`[name="${fieldName}"]`);
  if (!field) return true;

  if (field.name === "your-name") {
    if (field.value.trim() === "") {
      return validateFormFieldsSetError(field, "Introduce tu nombre")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  if (field.name === "your-email") {
    if (field.value.trim() === "") {
      return validateFormFieldsSetError(field, "Introduce tu correo electrónico")
    } else if (!validateEmail_cf(field.value.trim())) {
      return validateFormFieldsSetError(field, "Introduce un correo electrónico válido")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  if (field.name === "telefono") {
    const val = field.value.trim();
    if (val === "") {
      return validateFormFieldsSetError(field, "Introduce tu teléfono de contacto");
    } else if (!/^\d{9}$/.test(val)) {
      return validateFormFieldsSetError(field, "Introduce un teléfono válido");
    } else if (!/^[67]/.test(val)) {
      return validateFormFieldsSetError(field, "Introduce un teléfono que comience por 6 o 7");
    } else {
      return validateFormFieldsClearError(field);
    }
  }

  if (field.name === "car-details") {
    if (field.value.trim() === "" || field.value.trim().length < 5) {
      return validateFormFieldsSetError(field, "Introduce el coche que estás buscando")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  if (field.name === "contact-message") {
    if (field.value.trim() === "" || field.value.trim().length < 5) {
      return validateFormFieldsSetError(field, "Introduce tu mensaje")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  if (field.type === "checkbox") {
    if (!field.checked) {
      field.closest('.c-checkbox__label-wrap').classList.add("required-form-error");
      field.nextElementSibling.classList.add("required-form-error-before");
      return false;
    } else {
      field.closest('.c-checkbox__label-wrap').classList.remove("required-form-error");
      field.nextElementSibling.classList.remove("required-form-error-before");
      return true;
    }
  }

}

const validateFormFieldsSetError = (field, msg) => {
  field.classList.add("required-form-error");
  if (field.nextElementSibling) {
    field.nextElementSibling.innerHTML = msg;
  }
  return false;
}

const validateFormFieldsClearError = (field) => {
  field.classList.remove("required-form-error");
  if (field.nextElementSibling) {
    field.nextElementSibling.innerHTML = "";
  }
  return true;
}

var filtro_cliente = "";

function checkTypeClient(form_envio) {
  form_envio.addEventListener('submit', function (event) {
    if (!filtro_cliente) {
      event.preventDefault();
      alert("Tipo de cliente requerido");
    }
  });
}

function prepararEnvioF(id, formElement) {
  var idTrim = (typeof id === 'string') ? id.trim() : '';
  var form_envio = formElement || (idTrim ? document.querySelector("[data-id='" + idTrim + "']") : null);
  if (!form_envio && idTrim) {
    form_envio = document.getElementById(idTrim);
  }
  if (!form_envio) return false;

  var getVal = function (selector) {
    var el = form_envio.querySelector(selector);
    return el ? el.value.trim() : "";
  };

  var nombre = getVal("input[name='your-name']");
  var email = getVal("input[name='your-email']");
  var telefono = getVal("input[name='telefono']");
  var url_guardada = getVal("input[name='url_guardada']");
  if (!url_guardada) {
    var urlInputInDoc = document.querySelector("input[name='url_guardada']");
    if (urlInputInDoc && urlInputInDoc.value) {
      url_guardada = urlInputInDoc.value;
    } else {
      url_guardada = window.location.href.split('?')[0];
    }
  }

  var utm_source = getVal("input[name='utm_source']");

  var boletinEl = form_envio.querySelector("input[name='boletin']");
  var boletin = (boletinEl && boletinEl.checked) ? "1" : "0";

  var clientTypeEl = form_envio.querySelector("input[name='client-type']:checked") || form_envio.querySelector("input[name='client-type']");
  filtro_cliente = clientTypeEl ? clientTypeEl.value : "";
  if (filtro_cliente === 'Autónomo') {
    filtro_cliente = 'Autonomo';
  }

  var comentariosemail = "";
  var textareaEl = document.querySelector("textarea[name='car-details']");
  if (textareaEl) {
    comentariosemail = textareaEl.value.trim();
  }

  var clientTypeContainer = form_envio.querySelector(".client-type-container");
  if (clientTypeContainer) {
    var radioButtons = clientTypeContainer.querySelectorAll("input[name='client-type']");
    if (radioButtons.length > 0) {
      checkTypeClient(form_envio);
    }
  }

  var telef = /^[67]\d{8}$/;
  if (!telef.test(telefono)) {
    return false;
  }

  if (!validateEmail_cf(email)) {
    return false;
  }

  if (nombre === "") {
    return false;
  }

  var precio = "";
  var $scope = jQuery(form_envio).closest(".card-single, .combo, .card-detail, .c-selector, .c-product-detail, body");
  var priceEl = $scope.find('p#item-price-down, .item-price-down, #item-price-down, .c-selector__price__value, p#item-price, .item-price').first();
  if (priceEl.length === 0) {
    priceEl = jQuery('p#item-price-down, .item-price-down, #item-price-down, .c-selector__price__value, p#item-price, .item-price').first();
  }
  if (priceEl.length > 0) {
    var textPrice = priceEl.text().trim();
    var matchPrice = textPrice.match(/\d+([.,]\d+)?/);
    if (matchPrice) {
      precio = matchPrice[0];
    }
  }

  var km = "";
  var meses = "";
  var idcampana_val = "";
  var idcolor_val = "";

  var container = form_envio.closest(".card-single, .combo, .card-detail, .wrapper-selects, .block--inputs, .c-selector");

  if (!container) {
    var parent = form_envio.parentElement;
    container = parent ? parent.querySelector(".wrapper-selects, .block--inputs") : null;
    if (!container) {
      container = parent;
    }
  }

  if (!container) container = document;

  var kmInput = form_envio.querySelector('.kmvar');
  var mesesInput = form_envio.querySelector('.mesesvar');
  var idcampanaInput = form_envio.querySelector('[name="idcampana"], [id^="idcampana"]');
  var idcolorInput = form_envio.querySelector('[name="idcolor"], [id^="idcolor"]');

  if (!kmInput || !kmInput.value) {
    var kmInContainer = container.querySelector('.kmvar');
    if (kmInContainer && kmInContainer.value) kmInput = kmInContainer;
  }
  if (!mesesInput || !mesesInput.value) {
    var mesesInContainer = container.querySelector('.mesesvar');
    if (mesesInContainer && mesesInContainer.value) mesesInput = mesesInContainer;
  }
  if (!idcampanaInput || !idcampanaInput.value) {
    var campInContainer = container.querySelector('[name="idcampana"], [id^="idcampana"]');
    if (campInContainer && campInContainer.value) idcampanaInput = campInContainer;
  }
  if (!idcolorInput || !idcolorInput.value) {
    var colorInContainer = container.querySelector('[name="idcolor"], [id^="idcolor"]');
    if (colorInContainer && colorInContainer.value) idcolorInput = colorInContainer;
  }

  var forms = Array.from(document.querySelectorAll('form.c-form__wrapper'));
  var formIndex = forms.indexOf(form_envio) + 1;

  if (!kmInput || (!kmInput.value && kmInput.form)) {
    var kmBySuffix = document.getElementById('km_' + formIndex) || document.getElementById('km' + (formIndex === 1 ? '' : '_' + formIndex));
    if (kmBySuffix && kmBySuffix.value) kmInput = kmBySuffix;
  }
  if (!mesesInput || (!mesesInput.value && mesesInput.form)) {
    var mesesBySuffix = document.getElementById('meses_' + formIndex) || document.getElementById('meses' + (formIndex === 1 ? '' : '_' + formIndex));
    if (mesesBySuffix && mesesBySuffix.value) mesesInput = mesesBySuffix;
  }
  if (!idcampanaInput || !idcampanaInput.value) {
    var campBySuffix = document.getElementById('idcampana_' + formIndex) || document.getElementById('idcampana' + (formIndex === 1 ? '' : '_' + formIndex));
    if (campBySuffix && campBySuffix.value) idcampanaInput = campBySuffix;
  }
  if (!idcolorInput || !idcolorInput.value) {
    var colorBySuffix = document.getElementById('idcolor_' + formIndex) || document.getElementById('idcolor' + (formIndex === 1 ? '' : '_' + formIndex));
    if (colorBySuffix && colorBySuffix.value) idcolorInput = colorBySuffix;
  }

  /* 
  Global fallback to km and months:
  Take some rate selector cause everyone are sync, and get his km element and meses element to capture its values later
  */
  if (!kmInput || !kmInput.value) {
    var globalKmInput = document.querySelector('[id^="km_"].kmvar');

    if (globalKmInput && globalKmInput.value) {
      kmInput = globalKmInput;
    }
  }

  if (!mesesInput || !mesesInput.value) {
    var globalMesesInput = document.querySelector('[id^="meses_"].mesesvar');

    if (globalMesesInput && globalMesesInput.value) {
      mesesInput = globalMesesInput;
    }
  }

  if (kmInput) km = kmInput.value || "";
  if (mesesInput) meses = mesesInput.value || "";
  if (idcampanaInput) idcampana_val = idcampanaInput.value || "";
  if (idcolorInput) idcolor_val = idcolorInput.value || "";

  if (!km) {
    var selectedKm = container.querySelector('[id^="select-km"] .c-custom-select__value');
    if (selectedKm) {
      km = selectedKm.textContent.replace(/\D/g, '');
    }
  }
  if (!meses) {
    var selectedMeses = container.querySelector('[id^="select-meses"] .c-custom-select__value');
    if (selectedMeses) {
      meses = selectedMeses.textContent.replace(/\D/g, '');
    }
  }

  // --- idcampana_val resolution ---
  if (idcampanaInput && idcampanaInput.value) {
    idcampana_val = idcampanaInput.value;
  }
  if (!idcampana_val && container) {
    var campInContainer = container.querySelector('[name="idcampana"], [id^="idcampana"]');
    if (campInContainer && campInContainer.value) idcampana_val = campInContainer.value;
  }
  if (!idcampana_val && container && container !== document) {
    var activeCampLi = container.querySelector('.checking li.active[data-idcampana]');
    if (activeCampLi) idcampana_val = activeCampLi.getAttribute('data-idcampana') || "";
  }
  if (!idcampana_val) {
    var activeCampLiDoc = document.querySelector('.checking li.active[data-idcampana]');
    if (activeCampLiDoc) idcampana_val = activeCampLiDoc.getAttribute('data-idcampana') || "";
  }
  if (!idcampana_val && container && container !== document) {
    var anyCampLi = container.querySelector('.checking li[data-idcampana]');
    if (anyCampLi) idcampana_val = anyCampLi.getAttribute('data-idcampana') || "";
  }
  if (!idcampana_val) {
    var anyCampLiDoc = document.querySelector('.checking li[data-idcampana]');
    if (anyCampLiDoc) idcampana_val = anyCampLiDoc.getAttribute('data-idcampana') || "";
  }
  if (!idcampana_val && typeof window.idcampana !== 'undefined' && window.idcampana) {
    idcampana_val = window.idcampana;
  }

  // --- idcolor_val resolution ---
  if (idcolorInput && idcolorInput.value) {
    idcolor_val = idcolorInput.value;
  }
  if (!idcolor_val && container) {
    var colorInContainer = container.querySelector('[name="idcolor"], [id^="idcolor"]');
    if (colorInContainer && colorInContainer.value) idcolor_val = colorInContainer.value;
  }
  if (!idcolor_val && container && container !== document) {
    var activeColorLi = container.querySelector('.checking li.active[data-name]');
    if (activeColorLi) idcolor_val = activeColorLi.getAttribute('data-name') || "";
  }
  if (!idcolor_val) {
    var activeColorLiDoc = document.querySelector('.checking li.active[data-name]');
    if (activeColorLiDoc) idcolor_val = activeColorLiDoc.getAttribute('data-name') || "";
  }
  if (!idcolor_val && container && container !== document) {
    var anyColorLi = container.querySelector('.checking li[data-name]');
    if (anyColorLi) idcolor_val = anyColorLi.getAttribute('data-name') || "";
  }
  if (!idcolor_val) {
    var anyColorLiDoc = document.querySelector('.checking li[data-name]');
    if (anyColorLiDoc) idcolor_val = anyColorLiDoc.getAttribute('data-name') || "";
  }
  if (!idcolor_val && typeof window.idcolor !== 'undefined' && window.idcolor) {
    idcolor_val = window.idcolor;
  }


  if (nombre != "" && email != "" && telefono != "") {
    var kmSelectedLabel = '';
    if (kmInput) {
      kmSelectedLabel = kmInput.options ? kmInput.options[kmInput.selectedIndex].text.trim() : (km + ' Km');
    }
    var mesesSelectedLabel = '';
    if (mesesInput) {
      mesesSelectedLabel = mesesInput.options ? mesesInput.options[mesesInput.selectedIndex].text.trim() : (meses + ' Meses');
    }

    var km_consultados_arr = Array.from(_km_consultados_set).filter(function (v) {
      return v !== kmSelectedLabel;
    });

    var duracion_consultadas_arr = Array.from(_duracion_consultadas_set).filter(function (v) {
      return v !== mesesSelectedLabel;
    });

    var dlPayload = {
      'event': 'form-id-84',
      'email': email,
      'telefono': telefono,
      'km_seleccionado': kmSelectedLabel,
      'duracion_seleccionada': mesesSelectedLabel
    };

    if (km_consultados_arr.length > 0) {
      dlPayload['km_consultados'] = km_consultados_arr.join(', ');
    }
    if (duracion_consultadas_arr.length > 0) {
      dlPayload['duracion_consultadas'] = duracion_consultadas_arr.join(', ');
    }
    pushConGate(dlPayload);

    _km_consultados_set.clear();
    _duracion_consultadas_set.clear();

    send2db(nombre, email, telefono, precio, url_guardada, utm_source, boletin, filtro_cliente, comentariosemail, null, km, meses, idcampana_val, idcolor_val);
  }
}

function prepararEnvio2mano(id) {
  var form_envio = document.getElementById("formulario-envio-" + id);
  form_envio.reportValidity();

  var nombre = document.getElementById(id + "your-name").value;
  var email = document.getElementById(id + "your-email").value;
  var telefono = document.getElementById(id + "telefono").value;
  var url_guardada = document.getElementById(id + "url_guardada").value;
  var precio = document.getElementById("precio_modal_" + id).innerHTML;
  var utm_source = document.getElementById(id + "utm_source").value;
  var boletin = "0";
  if (document.getElementById(id + "boletin").checked) {
    boletin = "1";
  }

  var telef = /^[67]\d{8}$/;

  if (telef.test(telefono)) {
    console.log("valor correcto");
  } else {
    console.log("INTRODUCE OTRO VALOR. EJ: +34666555444");
    return false;
  }
  if (validateEmail_cf(email)) {
    console.log("Correo electrónico válido");
  } else {
    console.log("Correo electrónico inválido");
    return false;
  }
  if (nombre == "") {
    console.log("Nombre inválido");
    return false;
  }


  var id_km = 'km_' + id;
  var e = document.getElementById(id_km);
  var km = e.options[e.selectedIndex].value;

  console.log(" nombre:'" + nombre + "' /email: '" + email + "' /telefono: '" + telefono + "' /precio: " + precio + " /url_guardada: " + url_guardada + " /utm_source: " + utm_source + " /boletin: " + boletin);
  if (nombre != "" && email != "" && telefono != "") {
    pushConGate({ 'event': 'form-id-84', 'email': email, 'telefono': telefono });
    send2db(nombre, email, telefono, precio, url_guardada, utm_source, boletin, "", "", id);
  }

}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
//funcion send2db : envía todos los datos a pooltodb.php para insertar en webcrm (y hace cosas de criteo)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function send2db(nombre, email, telefono, precio, url_guardada, utm_source, boletin, filtro_cliente, comentariosemail, id_oferta = null, km_param = null, meses_param = null, idcampana_param = null, idcolor_param = null) {

  // --- gettheid (id del producto en WordPress) ---
  var gettheid_element = document.getElementById("gettheid");
  var gettheid = "";
  if (gettheid_element != null) {
    gettheid = gettheid_element.innerHTML;
  } else {
    // segunda mano / instancias con sufijo
    var candidates = ["gettheid_1", "gettheid_2"];
    for (var ci = 0; ci < candidates.length; ci++) {
      var el = document.getElementById(candidates[ci]);
      if (el != null) { gettheid = el.innerHTML; break; }
    }
  }

  if (id_oferta != null) {
    gettheid = id_oferta;
  }

  if (!url_guardada) {
    var urlInputInDoc = document.querySelector("input[name='url_guardada']");
    if (urlInputInDoc && urlInputInDoc.value) {
      url_guardada = urlInputInDoc.value;
    } else {
      url_guardada = window.location.href.split('?')[0];
    }
  }

  if (!precio) {
    var priceEl = jQuery('p#item-price-down, .item-price-down, #item-price-down, .c-selector__price__value, p#item-price, .item-price').first();
    if (priceEl.length > 0) {
      var textPrice = priceEl.text().trim();
      var matchPrice = textPrice.match(/\d+([.,]\d+)?/);
      if (matchPrice) {
        precio = matchPrice[0];
      }
    }
  }

  // --- km ---
  var km = "";
  if (km_param !== '' && km_param !== null) {
    km = km_param;
  } else if (id_oferta != null) {
    var id_km = 'km_' + id_oferta;
    var e = document.getElementById(id_km);
    if (e) {
      km = e.options ? e.options[e.selectedIndex].value : e.value;
    }
  } else {
    var km_element = document.getElementById("km");
    if (km_element != null) {
      km = km_element.value;
    }
  }

  // --- meses ---
  var meses = "";
  if (meses_param !== '' && meses_param !== null) {
    meses = meses_param;
  } else if (id_oferta != null) {
    meses = 12;
  } else {
    var meses_element = document.getElementById("meses");
    if (meses_element != null) {
      meses = meses_element.value;
    }
  }

  // --- idcampana / idcolor ---
  var idcampana = "";
  var idcolor = "";

  if (idcampana_param !== null && idcampana_param !== "") {
    idcampana = idcampana_param;
  } else {
    var idcampana_el = document.getElementById("idcampana");
    if (idcampana_el != null && idcampana_el.value) {
      idcampana = idcampana_el.value;
    } else {
      for (var si = 1; si <= 2; si++) {
        var ic_el = document.getElementById("idcampana_" + si);
        if (ic_el != null && ic_el.value) { idcampana = ic_el.value; break; }
      }
    }
    if (!idcampana) {
      var activeCampLi = document.querySelector('.checking li.active[data-idcampana]');
      if (activeCampLi) {
        idcampana = activeCampLi.getAttribute('data-idcampana') || "";
      }
    }
    if (!idcampana) {
      var anyCampLi = document.querySelector('.checking li[data-idcampana]');
      if (anyCampLi) {
        idcampana = anyCampLi.getAttribute('data-idcampana') || "";
      }
    }
    if (!idcampana && typeof window.idcampana !== 'undefined') {
      idcampana = window.idcampana;
    }
  }

  if (idcolor_param !== null && idcolor_param !== "") {
    idcolor = idcolor_param;
  } else {
    var idcolor_el = document.getElementById("idcolor");
    if (idcolor_el != null && idcolor_el.value) {
      idcolor = idcolor_el.value;
    } else {
      for (var si = 1; si <= 2; si++) {
        var icol_el = document.getElementById("idcolor_" + si);
        if (icol_el != null && icol_el.value) { idcolor = icol_el.value; break; }
      }
    }
    if (!idcolor) {
      var activeColorLi = document.querySelector('.checking li.active[data-name]');
      if (activeColorLi) {
        idcolor = activeColorLi.getAttribute('data-name') || "";
      }
    }
    if (!idcolor) {
      var anyColorLi = document.querySelector('.checking li[data-name]');
      if (anyColorLi) {
        idcolor = anyColorLi.getAttribute('data-name') || "";
      }
    }
    if (!idcolor && typeof window.idcolor !== 'undefined') {
      idcolor = window.idcolor;
    }
  }

  console.log("send2db -> gettheid:", gettheid, "km:", km, "meses:", meses, "idcampana:", idcampana, "idcolor:", idcolor);


  if (typeof utm_source === 'undefined') {
    var utm_source = "";
  }
  if (url_guardada != "") {
    url_guardada.replace(new RegExp("&", 'g'), ":");
  }

  var baseUrl = window.location.origin;
  var hostname = window.location.hostname;
  var pedidodb = new Date().valueOf() + (Math.floor(Math.random() * 100) + 1) + (Math.floor(Math.random() * 100) + 1);
  if (filtro_cliente === 'Autónomo') {
    filtro_cliente = 'Autonomo';
  }
  var datastring = 'nombre=' + nombre + "&email=" + email + "&telefono=" + telefono + "&url=" + url_guardada + "&utm_source=" + utm_source + "&idproducto=" + gettheid + "&km=" + km + "&meses=" + meses + "&pedido=" + pedidodb + "&idcampana=" + idcampana + "&idcolor=" + idcolor + "&boletin=" + boletin + "&filtro_cliente=" + filtro_cliente + "&comentariosemail=" + comentariosemail;

  if (hostname === 'localhost') {
    var nuevo = url_guardada.indexOf("segunda-mano") === -1;
    var tipo = url_guardada.indexOf("renting-motos") !== -1 ? "motos" : "vehicle";
    var thankYouUrl = baseUrl + '/gracias/?id=' + pedidodb + "&idproducto=" + gettheid + "&precio=" + precio + "&nuevo=" + nuevo + "&cliente=" + filtro_cliente + "&tipo=" + tipo;
    location = thankYouUrl;
    return;
  }

  var targetEndpoint = "/pooltodb2.php";
  if (hostname === 'staging.rentingfinders.com') {
    targetEndpoint = "/pooltodb2_staging.php";
  } else if (hostname === 'rentingfinders.com' || hostname === 'www.rentingfinders.com' || hostname === 'renting-v5.string-projects.com') {
    targetEndpoint = "/pooltodb2.php";
  }

  var peticion = new XMLHttpRequest();

  peticion.open("POST", baseUrl + targetEndpoint, true);
  peticion.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=ISO-8859-1');

  peticion.onerror = function () {
    console.log('Woops, there was an error making the request.');
  };

  peticion.onreadystatechange = function () {
    if (peticion.readyState == 4) {
      if (peticion.status == 200) {
        try {
          var response = JSON.parse(peticion.responseText);
          console.log('R:' + peticion.responseText);
          console.log(response);

          var urlIframe = response.url_iframe || "";
          var nuevo = url_guardada.indexOf("segunda-mano") === -1;
          var tipo = url_guardada.indexOf("renting-motos") !== -1 ? "motos" : "vehicle";
          var destino = baseUrl + '/gracias/?id=' + pedidodb + "&idproducto=" + gettheid + "&precio=" + precio + "&nuevo=" + nuevo + "&cliente=" + filtro_cliente + "&bankflip=" + urlIframe + "&tipo=" + tipo;

          esperarGTM().then(function () { location = destino; });

        } catch (e) {
          console.error("Error al analizar JSON:", e);
          var destino = baseUrl + '/gracias/?id=' + pedidodb + "&idproducto=" + gettheid + "&precio=" + precio;
          esperarGTM().then(function () { location = destino; });
        }
      } else {
        console.error("Error en la petición. Estado:", peticion.status);
      }
    }
  };

  peticion.send(datastring);
}
